import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box } from '@material-ui/core';
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import TextField from "@material-ui/core/TextField";
import CancelIcon from '@mui/icons-material/Cancel';
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles({

  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
});

function Confirmation(props) {
  const classes = useStyles();
  const { onClose, open, onHandleSubmit, BMhistorydata, clickMode } = props;

  const handleClose = () => {

    onClose();
  };
  const handleSubmit = (status) => {
    //
    onHandleSubmit(status)
  };
  const oninputChange = (value, field) => {
    //
    props.onChange(value, field);

  }
  return (
    <Box >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // {BMhistorydata.length > 0 ?{fullScreen={true}:""}
        fullScreen={BMhistorydata.length > 0 ? true : ""}
        fullWidth={BMhistorydata.length > 0 ? true : ""}
      >
        <Box>
          <Button style={{ float: "right" }} onClick={handleClose}><CancelIcon /></Button>
        </Box>
        <Box p={5}>

          <DialogTitle id="alert-dialog-title">{BMhistorydata.length > 0 ? "Bunker Master Access User History Status" : "Are you sure you want to give approval to user?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {BMhistorydata.length > 0 ?
                <Box className={classes.root} pb={5} px={1}>
                  <TableContainer component={Paper} className={classes.tableLayout}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>UserName</StyledTableCell>

                          <StyledTableCell>Created BY</StyledTableCell>
                          <StyledTableCell>Created Date</StyledTableCell>
                          <StyledTableCell>BM Access Status</StyledTableCell>
                          <StyledTableCell>Reason</StyledTableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {BMhistorydata.map((row, idx) => (
                          <StyledTableRow key={idx}>

                            <StyledTableCell  >{row.username}</StyledTableCell>
                            <StyledTableCell  >{row.createdby}</StyledTableCell>
                            <StyledTableCell  >{row.createdDate}</StyledTableCell>
                            <StyledTableCell  >{row.bM_STATUS}</StyledTableCell>
                            <StyledTableCell  >{row.reason}</StyledTableCell>
                          </StyledTableRow>

                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                : clickMode == "BMaccess" ?
                  <Box component="span" ml={2} width="260px">
                    <Box component="span" fontSize="16px">
                      {"Reason:"}
                    </Box>

                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      name="search"
                      className={classes.txtInput}
                      placeholder="Type"
                      //value={searchText}
                      onChange={(e) => oninputChange(e.target.value, "reason")}
                    />

                  </Box>
                  : null}

            </DialogContentText>
          </DialogContent>
          <DialogActions textAlign="center">
            {BMhistorydata.length <= 0 ?
              <Box>
                <Button onClick={() => { handleSubmit('cancel') }} className={classes.btnStyle2} color="primary">
                  Cancel
                </Button>
                <Button onClick={() => { handleSubmit('reject') }} className={classes.btnStyle2} color="primary">
                  Reject
                </Button>
                <Button onClick={() => { handleSubmit('approval') }} className={classes.btnStyle2} color="primary" autoFocus>
                  Approve
                </Button>
              </Box>
              : ""}
          </DialogActions>
        </Box>
      </Dialog>
    </Box>
  )
}


export default Confirmation

